const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/certificates.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
interface Certificate {
  id: string;
  certificateNumber: string;
  certificateType: string;
  title: string;
  petName: string;
  petId: string | null;
  ownerName: string | null;
  bookingId: string | null;
  issuedByName: string | null;
  issuedAt: string;
  validFrom: string | null;
  validUntil: string | null;
  status: 'issued' | 'revoked';
  revokedAt: string | null;
  revokedReason: string | null;
  documentHash: string | null;
  data: Record<string, unknown> | null;
  remarks: string | null;
  createdAt: string;
}
export const Route = createFileRoute('/pro/dashboard/certificates')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});